import { z } from 'zod/v4';

export const accountSchema = z.object({
  id: z.number(),
  name: z.string(),
  alias: z.string(),
  netSuiteId: z.number().nullable(),
  createdBy: z.string().nullable(),
  modifiedBy: z.string().nullable(),
  expirationDate: z.string().nullable(),
  isPrimary: z.boolean(),
  isTest: z.boolean(),
  isFound: z.boolean(),
  isDeleted: z.boolean(),
  accountTypeId: z.number().nullable(),
  regionId: z.number().nullable(),
});

export const accountResponseSchema = accountSchema.omit({
  alias: true,
  netSuiteId: true,
  createdBy: true,
  modifiedBy: true,
  isFound: true,
  isDeleted: true,
});

export type Account = z.infer<typeof accountSchema>;
